export default "__VITE_ASSET__BWVCbMpp__"